import { createElement, useState } from "react";
import { type ReactElement } from "react";
import { pdf, type DocumentProps } from "@react-pdf/renderer";
import ChangeOrderPdf, {
  ChangeOrderPdfProps,
} from "Components/Common/ChangeOrderPdf/ChangeOrderPdf";

export const useChangeOrderPdf = () => {
  const [isExportingCoPdf, setIsExportingCoPdf] = useState(false);

  const exportChangeOrderPdf = async (props: ChangeOrderPdfProps) => {
    setIsExportingCoPdf(true);
    try {
      const el = createElement(
        ChangeOrderPdf,
        props,
      ) as ReactElement<DocumentProps>;
      const blob = await pdf(el).toBlob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `ChangeOrder-${props.coNumber || "draft"}-${new Date()
        .toISOString()
        .slice(0, 10)}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } finally {
      setIsExportingCoPdf(false);
    }
  };

  return { exportChangeOrderPdf, isExportingCoPdf };
};
